import { FeatureDecisionService } from '../services/feature-decision/feature-decision.service';
import { BaseCondition } from './base-condition';

export class UrlParamCondition implements BaseCondition {
  constructor(private readonly key: string, private readonly value: string) {}

  get searchParams() {
    return new URLSearchParams(window.location.search);
  }

  isAllowed(_service: FeatureDecisionService): boolean {
    return this.searchParams.get(this.key) === this.value;
  }
}
